import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TableType } from '../../models/communication/app-enums.model';

@Component({
    selector: 'app-waiting-for-croupier',
    imports: [CommonModule],
    templateUrl: './waiting-for-croupier.component.html',
    styleUrl: './waiting-for-croupier.component.scss'
})
export class WaitingForCroupierComponent {
    @Input()
    tableType?: TableType;

    get animationClass(): string {
        switch (this.tableType) {
            case TableType.RouletteTable:
                return 'insert-rfid-card-animation-roulette';
            default:
                return 'insert-rfid-card-animation';
        }
    }
}
